import { render, staticRenderFns } from "./milestone-view.vue?vue&type=template&id=73bfc4ee&scoped=true&"
import script from "./milestone-view.ts?vue&type=script&lang=ts&"
export * from "./milestone-view.ts?vue&type=script&lang=ts&"
import style0 from "./milestone-view.scss?vue&type=style&index=0&id=73bfc4ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bfc4ee",
  null
  
)

export default component.exports